const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3SensingPlus {
    constructor(runtime) { this.runtime = runtime; }
    getInfo() {
        return {
            id: 'sensingPlus', name: '🔎 センサー+', color1: '#5CB1D6', color2: '#47A0C7',
            blocks: [
                { opcode: 'mouseX', blockType: BlockType.REPORTER, text: 'マウスのX座標' },
                { opcode: 'mouseY', blockType: BlockType.REPORTER, text: 'マウスのY座標' },
                { opcode: 'mouseDown', blockType: BlockType.BOOLEAN, text: 'マウスが押されている？' },
                { opcode: 'stageWidth', blockType: BlockType.REPORTER, text: 'ステージの幅' },
                { opcode: 'stageHeight', blockType: BlockType.REPORTER, text: 'ステージの高さ' },
                { opcode: 'spriteCount', blockType: BlockType.REPORTER, text: 'スプライト数' },
                { opcode: 'currentFPS', blockType: BlockType.REPORTER, text: '現在のFPS' }
            ]
        };
    }
    mouseX() { return this.runtime ? this.runtime.ioDevices.mouse.getScratchX() : 0; }
    mouseY() { return this.runtime ? this.runtime.ioDevices.mouse.getScratchY() : 0; }
    mouseDown() { return this.runtime ? this.runtime.ioDevices.mouse.getIsDown() : false; }
    stageWidth() { return 480; }
    stageHeight() { return 360; }
    spriteCount() { return this.runtime ? this.runtime.targets.filter(function(t) { return t.isOriginal && !t.isStage; }).length : 0; }
    currentFPS() { return 30; }
}
module.exports = Scratch3SensingPlus;